var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStrikethrough(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27_2955)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.73 13.9998L13.01 14.1398C13.27 14.2898 13.46 14.4398 13.58 14.5798C13.7 14.7198 13.76 14.8798 13.76 15.0798C13.76 15.3798 13.61 15.6398 13.32 15.8298C13.02 16.0298 12.56 16.1298 11.93 16.1298C10.227 16.0508 8.55424 15.6505 7 14.9498V18.3198C8.52244 18.9872 10.1801 19.2886 11.84 19.1998C13.1 19.1998 14.19 19.0098 15.12 18.6398C16.05 18.2698 16.76 17.7398 17.26 17.0698C17.76 16.3998 18 15.6198 18 14.7498C18 14.4898 17.98 14.2398 17.94 13.9998H12.73ZM7.23 9.9998C7.15 9.6598 7.11 9.2998 7.11 8.8998C7.11 7.6098 7.63 6.5998 8.69 5.8798C9.74 5.1598 11.19 4.7998 13.03 4.7998C14.65 4.7998 16.31 5.1398 18 5.7998L16.7 8.7298C15.23 8.1298 13.97 7.8298 12.9 7.8298C12.35 7.8298 11.94 7.9098 11.7 8.0898C11.44 8.2598 11.32 8.4698 11.32 8.7298C11.32 8.9998 11.48 9.2498 11.8 9.4698C11.97 9.5898 12.33 9.7698 12.85 9.9998H7.23ZM3 12.9998H21V10.9998H3V12.9998Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27_2955"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrikethrough);
export default __webpack_public_path__ + "static/media/Strikethrough.fa2c03d3faa6adf40cf86e9faf52940a.svg";
export { ForwardRef as ReactComponent };